/* VitaFresh Rabatt-Balken: Gratis-Lieferung, Mengenrabatt und Rabattcodes im Warenkorb.
   Ersetzt die Cypher-Leiste. Zeigt, was Shopify im Warenkorb angewendet hat. Rabatte rechnet
   Shopify immer vom Brutto-Betrag. Das Prinzip (Pasci 2026-10-06): Der Balken zeigt immer die
   vier Stationen Gratis, 10, 12, 15 %. Ein Code färbt die Strecke gold, in der er gilt, und ein
   Satz unten sagt, wie er wirkt. Nur Codes über 15 % ersetzen die Stationen 10 und 12 (maximal
   drei Stationen). Aufbau: berechne(cart, gemerkterCode) ist rein und in Node testbar,
   html(modell) baut das Markup, der Rest ist DOM.
   Eingebunden in layout/theme.liquid per snippets/vf-rabatt-balken.liquid. */
(function (root) {
  "use strict";

  /* Stufen aus einer Quelle (20.10.2026): Metaobjekte «Rabattstufe» über assets/vf-warenkorb-basis.js (heute Gratis-Lieferung
     ab 100, Mengenrabatt 10/12/15 % ab 150/200/300; im Shop drei automatische Rabatte «10%», «2%», «3%», die sich addieren).
     K(): { gratis (CHF), stufen [{ ab, prozent, titel }], titel { Rabatt-Titel: Prozentpunkte } }. Fehlt die Basis, kein Balken
     (lieber keiner als einer mit falschen Zahlen). */
  var basisNode = null, kTest = null;
  if (typeof module !== "undefined" && module.exports) { try { basisNode = require("./vf-warenkorb-basis.js"); } catch (e) { basisNode = null; } }
  function K() {
    if (kTest) return kTest;
    var b = root.VFWarenkorbBasis || basisNode;
    return b ? b.lesen() : null;
  }
  function thr() { var k = K(); return [k.gratis].concat(k.stufen.map(function (x) { return x.ab; })); }
  function top() { var k = K(); return k.stufen[k.stufen.length - 1]; }
  var NAHE_GRENZE = 15; /* CHF: darunter leuchtet der nächste Schritt */
  var NB = "\u00a0";

  function chf(v) { return "CHF " + v.toFixed(2); }
  function norm(s) { return String(s || "").replace(/\s+/g, "").toUpperCase(); }
  function nb(s) { return String(s).replace(/ /g, NB); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (z) { return "&#" + z.charCodeAt(0) + ";"; }); }
  function frk(v) { return v % 1 === 0 ? String(v) : v.toFixed(2); }
  function zahl(v) { return String(v).replace(".", ","); }

  function stp(w) { var p = 0; K().stufen.forEach(function (x) { if (w >= x.ab) p = x.prozent; }); return p; }
  /* Erster Warenwert (CHF), ab dem der Mengenrabatt den Code ablöst. null = nie.
     Geprüft im Shop (06.10.2026): Bei Gleichstand gilt der automatische Mengenrabatt, der Code
     ist dann «nicht anwendbar». Also gilt der Code nur unter diesem Warenwert. */
  function wende(c) {
    if (c.typ !== "pct") return null; /* Betragsrabatte sind kombinierbar, sie werden nie abgelöst */
    var t = thr();
    for (var i = 1; i < t.length; i++) if (stp(t[i]) >= c.wert) return t[i];
    return null;
  }

  function normal(w, nach, vfp) {
    var k = K();
    var l = [{ typ: "gratis", label: "Gratis", sub: "ab" + NB + "CHF" + NB + k.gratis, an: nach >= k.gratis, thr: k.gratis }];
    k.stufen.forEach(function (s) {
      l.push({ typ: "staffel", label: s.prozent + NB + "%", sub: "ab" + NB + "CHF" + NB + s.ab, an: vfp > 0 ? s.prozent <= vfp : w >= s.ab, thr: s.ab });
    });
    return l;
  }

  /* Stationen: Gratis und alle Stufen. Ausnahmen mit Code: über der höchsten Stufe (heute 15 %) nur Gratis, höchste Stufe, Code;
     genau so viel wie die höchste Stufe (WELCOME15) nur Gratis und Code. */
  function stationen(c, w, nach, vfp) {
    var l = normal(w, nach, vfp);
    if (!c || c.kombi || c.typ !== "pct") return l;
    var o = top();
    if (c.wert > o.prozent) {
      return [l[0], { typ: "staffel", label: o.prozent + NB + "%", sub: "max." + NB + "ab" + NB + "CHF" + NB + o.ab, an: w >= o.ab, thr: o.ab },
        { typ: "code", label: nb(zahl(c.wert) + " %"), sub: "Dein Code", an: true, thr: 0 }];
    }
    if (c.wert === o.prozent) return [l[0], { typ: "code", label: o.prozent + NB + "%", sub: "Dein Code", an: true, thr: 0 }];
    return l;
  }

  /* Rabatt-Anwendungen aus beiden Ebenen von /cart.js: Warenkorb und Zeilen. Shopify legt Rabatte
     auf Artikel (Mengenrabatt, Segment-Kundenrabatte) auf Zeilen-Ebene ab. */
  function alleApps(cart) {
    var out = (cart.cart_level_discount_applications || []).slice(), bekannt = {}, zeilen = {};
    out.forEach(function (a) { bekannt[a.type + "|" + a.title] = true; });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var d = al.discount_application, k = d && d.type + "|" + d.title;
        if (!d || bekannt[k]) return;
        if (!zeilen[k]) {
          zeilen[k] = { type: d.type, title: d.title, value: d.value, value_type: d.value_type, total_allocated_amount: 0 };
          out.push(zeilen[k]);
        }
        zeilen[k].total_allocated_amount += al.amount || 0;
      });
    });
    return out;
  }

  function berechne(cart, gemerkt) {
    if (!cart || !cart.item_count) return { zeigen: false, grund: "leer" };
    var k = K();
    if (!k) return { zeigen: false, grund: "ohne-stufen" };
    var STAFFEL_TITEL = k.titel, GRATIS_RAPPEN = k.gratis * 100, oben = top();
    var apps = alleApps(cart);
    /* Geschenkkarten bekommen keinen Rabatt (Pasci 15.10.2026) und zählen nicht zum Warenwert: weder für Stufen noch für
       die Gratis-Lieferung. Nur Geschenkkarten im Warenkorb: kein Balken. Alles in Rappen. */
    var geschenk = 0, hatWare = false;
    (cart.items || []).forEach(function (it) {
      if (it.gift_card) geschenk += it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
      else hatWare = true;
    });
    if (geschenk > 0 && !hatWare) return { zeigen: false, grund: "geschenkkarte" };
    var brutto = (cart.original_total_price || 0) - geschenk; /* erst zur Anzeige in Franken */
    var nachR = (cart.total_price != null ? cart.total_price : (cart.original_total_price || 0) - (cart.total_discount || 0)) - geschenk;
    var warenwert = brutto / 100, nach = nachR / 100, spar = (brutto - nachR) / 100;
    var autoPct = 0, hatStaffel = false, vfp = 0, code = null, abgelehnt = null;
    var i, a, m;
    for (i = 0; i < apps.length; i++) {
      a = apps[i];
      if (a.type === "automatic") {
        var key = String(a.title || "").replace(/\s+/g, "");
        if (Object.prototype.hasOwnProperty.call(STAFFEL_TITEL, key)) { autoPct += STAFFEL_TITEL[key]; hatStaffel = true; }
        else return { zeigen: false, grund: "kundenrabatt" }; /* KMU, Familie, Wiederverkauf usw. */
      } else if (a.type === "discount_code") {
        m = norm(a.title).match(/^VFP-(\d{1,2})$/); /* Portal-Code = Mengenrabatt des Bestell-Portals */
        if (m) vfp = Math.max(vfp, parseInt(m[1], 10));
        else if (!code) code = { name: String(a.title || "").trim().toUpperCase(), alloc: (a.total_allocated_amount || 0) / 100, vt: a.value_type, pct: parseFloat(a.value) };
      }
    }

    /* cart.js nennt auch Codes, die nicht angewendet sind (applicable: false), z. B. weil der
       Mengenrabatt höher ist. Portal-Codes und WELCOME15 bleiben ohne Hinweis. */
    var dcs = cart.discount_codes || [];
    for (i = 0; i < dcs.length; i++) {
      if (dcs[i].applicable === false && !/^VFP-\d{1,2}$/.test(norm(dcs[i].code)) && norm(dcs[i].code) !== "WELCOME15" && !abgelehnt) abgelehnt = String(dcs[i].code).trim().toUpperCase();
    }

    var c = null, vorbei = false, merken = null;
    if (code) {
      var chfCode = code.vt === "fixed_amount";
      c = {
        typ: chfCode ? "chf" : "pct",
        wert: chfCode ? Math.round(code.alloc * 100) / 100 : (code.pct > 0 ? code.pct : (warenwert > 0 ? Math.round(code.alloc / warenwert * 1000) / 10 : 0)),
        code: code.name, welcome: code.name === "WELCOME15", kombi: hatStaffel || chfCode /* Betragsrabatte (z. B. Treuepunkte) sind kombinierbar, Prozent-Codes nicht (Pasci 06.10.2026) */
      };
      if (!c.kombi && !c.welcome) merken = { typ: c.typ, wert: c.wert, code: c.code };
    } else if (abgelehnt && (autoPct > 0 || vfp > 0)) {
      /* Der Code gilt nicht, weil der Mengenrabatt höher ist. Kennen wir seinen Wert aus dieser
         Sitzung, zeigen wir die Zone, sonst nur den Hinweis. */
      if (gemerkt && gemerkt.code === abgelehnt) c = { typ: gemerkt.typ, wert: gemerkt.wert, code: gemerkt.code, welcome: false, kombi: false };
      else c = { typ: null, wert: 0, code: abgelehnt, welcome: false, kombi: false };
      vorbei = true;
    }

    var pctAktiv = autoPct || vfp || (c ? 0 : stp(warenwert));
    var gratis = nachR >= GRATIS_RAPPEN, fehlt = (GRATIS_RAPPEN - nachR) / 100;
    var liste = stationen(c, warenwert, nach, vfp);
    var drei = liste.some(function (s) { return s.typ === "code"; });
    var T = c && !c.kombi && c.typ && !c.welcome ? wende(c) : null;
    var zoneEnd = null;
    if (c && !drei && !c.kombi && T !== null) zoneEnd = thr().reduce(function (r, x, j) { return x <= T ? j : r; }, 0);
    var label = c && c.typ ? (c.typ === "pct" ? nb(zahl(c.wert) + " %") : nb("CHF " + frk(c.wert))) : "";
    var next = k.stufen.map(function (x) { return x.ab; }).filter(function (x) { return warenwert < x; })[0];

    /* Satz unten (Kleingedrucktes) */
    var unter;
    if (!c) {
      if (!gratis) unter = "Ab CHF " + k.gratis + " liefern wir gratis";
      else if (pctAktiv >= oben.prozent || !next) unter = "Mehr Rabatt gibt es nicht";
      else unter = "Noch " + chf(next - warenwert) + " bis " + stp(next) + " %";
    } else if (c.welcome) unter = "Willkommens-Code " + c.code + ": 15 % auf Deine Erstbestellung. Sonst gibt es " + oben.prozent + " % ab CHF " + oben.ab + ".";
    else if (c.kombi) unter = "Dein Code " + c.code + " ist kombinierbar mit unseren Mengenrabatten.";
    else if (!c.typ) unter = "Dein Code " + c.code + " wurde nicht angewendet. Es gilt unser Mengenrabatt.";
    else if (T !== null) unter = "Dein Code " + c.code + " gilt unter CHF " + frk(T) + ". Ab CHF " + frk(T) + " gelten unsere Mengenrabatte.";
    else unter = "Dein Code " + c.code + " ist besser als unsere Mengenrabatte.";

    /* Fette Zeile: der nächste Schritt */
    var titel, icon, ton;
    if (!gratis) {
      titel = "Noch " + chf(fehlt) + " bis Gratis-Lieferung";
      icon = fehlt <= NAHE_GRENZE ? "hoch" : "wagen"; ton = fehlt <= NAHE_GRENZE ? "naeher" : (c ? "sicher" : "offen");
    } else if (c && c.kombi) {
      titel = (pctAktiv > 0 ? pctAktiv + " % Mengenrabatt + " : "") + label + " mit Deinem Code"; icon = "haken"; ton = "sicher";
    } else if (c && vorbei) {
      titel = pctAktiv >= oben.prozent ? "Beste Stufe: " + oben.prozent + " % auf alles" : "Unser Mengenrabatt " + pctAktiv + " % gilt";
      icon = pctAktiv >= oben.prozent ? "stern" : "haken"; ton = pctAktiv >= oben.prozent ? "top" : "sicher";
    } else if (c && T === null) {
      titel = c.welcome ? "15 % auf alles, ab dem ersten Franken" : "Dein Code " + c.code + ": " + label + " auf alles"; icon = "stern"; ton = "top";
    } else if (c && T > warenwert) {
      titel = "Noch " + chf(T - warenwert) + " bis zu unserem Mengenrabatt"; icon = "hoch"; ton = "sicher";
    } else if (pctAktiv >= oben.prozent) {
      titel = "Beste Stufe: " + oben.prozent + " % auf alles"; icon = "stern"; ton = "top";
    } else {
      titel = pctAktiv > 0 && (autoPct > 0 || vfp > 0 || spar > 0) ? pctAktiv + " % Rabatt gesichert" : "Gratis-Lieferung gesichert"; icon = "haken"; ton = "sicher";
    }

    return {
      zeigen: true, geschenk: geschenk > 0, warenwert: warenwert, nach: nach, spar: spar, pct: pctAktiv, ton: ton, icon: icon, titel: titel, unter: unter,
      stationen: liste, zoneEnd: zoneEnd, vorbei: vorbei,
      chip: (c && !drei && (zoneEnd !== null || c.kombi)) ? "Code " + c.code + ": " + (c.kombi ? "+ " : "") + label : null,
      codeMerken: merken
    };
  }

  var ICON = {
    wagen: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    haken: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    hoch: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="M6 11l6-6 6 6"/></svg>',
    stern: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.8z"/></svg>',
    code: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12V4h8l9 9-8 8z"/><circle cx="7.5" cy="8.5" r="1.3"/></svg>'
  };

  function html(m) {
    var l = m.stationen, n = l.length, k = 0, i;
    /* Fortschritt: führende erreichte Stationen plus Anteil zur nächsten */
    while (k < n && l[k].an && l[k].typ !== "code") k++;
    var teil = 0, nxt = l[k];
    if (nxt && nxt.typ !== "code") {
      var prev = k > 0 ? l[k - 1].thr : 0, x = nxt.typ === "gratis" ? m.nach : m.warenwert;
      teil = Math.max(0, Math.min(1, (x - prev) / Math.max(1, nxt.thr - prev)));
    }
    var frac = k === 0 ? 0 : (k - 1) + teil;
    var spur = Math.round(Math.min(n - 1, frac) / n * 1000) / 10;
    var naechste = -1;
    for (i = 0; i < n; i++) if (!l[i].an) { naechste = i; break; }
    var punkte = l.map(function (s, j) {
      var g = s.typ === "gratis", c = s.typ === "code";
      var cls = "vfrb-pfad__st" + (s.an ? " vfrb-an" : "") + (j === naechste ? " vfrb-naechste" : "") + (g ? " vfrb-pfad__st--gratis" : "") + (c ? " vfrb-code" : "");
      var badge = g && s.an ? '<span class="vfrb-pfad__badge">' + ICON.haken + "</span>" : "";
      var pt = g ? ICON.wagen : (c ? ICON.code : (s.an ? ICON.haken : ""));
      return '<li class="' + cls + '">' + badge + '<span class="vfrb-pfad__pt">' + pt + "</span><b>" + esc(s.label) + "</b><small>" + esc(s.sub) + "</small></li>";
    }).join("");
    var zone = m.zoneEnd > 0 ? '<span class="vfrb-pfad__zone' + (m.vorbei ? " vfrb-vorbei" : "") + '" style="width:calc(' + m.zoneEnd + ' / var(--n) * 100%)"></span>' : "";
    var codespur = l[n - 1].typ === "code" && n >= 2 ? '<span class="vfrb-pfad__codespur"></span>' : "";
    var chip = m.chip ? '<div class="vfrb-chip' + (m.vorbei ? " vfrb-vorbei" : "") + '"><span>' + ICON.code + " " + esc(m.chip) + "</span></div>" : "";
    var held = m.spar > 0 ? '<div class="vfrb-held"><small>Du sparst</small><b>' + chf(m.spar) + "</b></div>" : "";
    return '<section class="vfrb vfrb--' + m.ton + '" aria-label="Gratis-Lieferung, Mengenrabatt und Rabattcode"><div class="vfrb__kern">' + chip + held +
      '<ol class="vfrb-pfad" style="--n:' + n + '">' + zone + '<span class="vfrb-pfad__spur" style="width:' + spur + '%"></span>' + codespur + punkte + "</ol></div>" +
      '<div class="vfrb__fuss"><span class="vfrb__fussicon">' + ICON[m.icon] + "</span><span><b>" + esc(m.titel) + "</b><small>" + esc(m.unter) + "</small>" + (m.geschenk ? "<small>Geschenkkarten sind von allen Rabatten ausgenommen.</small>" : "") + "</span></div></section>";
  }

  var api = { berechne: berechne, html: html, wende: wende, thr: thr, _stufen: function (k) { kTest = k; } };
  if (typeof module !== "undefined" && module.exports) { module.exports = api; return; }
  if (root.VFRB) return; /* Snippet doppelt eingebunden: nur eine Instanz */
  root.VFRB = api;

  /* ---- Browser: Balken über dem Warenkorb einsetzen und aktuell halten ---- */
  var doc = root.document;
  var letzteAnfrage = 0, anfrageNr = 0;
  var timer = null, nachholen = null;
  var skript = doc.currentScript || doc.querySelector('script[src*="vf-rabatt-balken"]');
  var startAnzahl = skript ? parseInt(skript.getAttribute("data-anzahl"), 10) : NaN; /* vom Snippet: cart.item_count beim Seitenaufbau (fehlt: wie bisher holen) */

  function anker() {
    var all = doc.querySelectorAll(".cart-section, .cart-form");
    return Array.prototype.filter.call(all, function (el) {
      return !el.parentElement || !el.parentElement.closest(".cart-section, .cart-form");
    });
  }

  /* Genau eine Box je Warenkorb-Bereich. Rendert das Theme den Warenkorb neu oder schiebt etwas vor
     den Anker, bleibt es bei einer Box: Jeder Anker bekommt eine Nummer, die Box trägt sie auch,
     Doppelte und Waisen werden entfernt. */
  var ankerNr = 0;
  function zeichne(m) {
    var html_ = m.zeigen ? html(m) : "";
    var liste = anker(), ids = {};
    liste.forEach(function (el) {
      var id = el.getAttribute("data-vfrb-anker");
      if (!id) { id = String(++ankerNr); el.setAttribute("data-vfrb-anker", id); }
      ids[id] = true;
    });
    Array.prototype.forEach.call(doc.querySelectorAll(".vfrb-box[data-vfrb-fuer]"), function (box) {
      if (!ids[box.getAttribute("data-vfrb-fuer")] || !m.zeigen) box.remove();
    });
    if (!m.zeigen) return;
    liste.forEach(function (el) {
      var id = el.getAttribute("data-vfrb-anker");
      var boxen = doc.querySelectorAll('.vfrb-box[data-vfrb-fuer="' + id + '"]');
      var box = boxen[0];
      for (var i = 1; i < boxen.length; i++) boxen[i].remove();
      if (!box) {
        box = doc.createElement("div");
        box.className = "vfrb-box";
        box.setAttribute("data-vfrb-fuer", id);
        box.setAttribute("data-vfrb", "");
      }
      /* Steht im Theme ein Platz für den Balken (data-vfrb-slot, Mini-Warenkorb und Warenkorbseite), kommt er dorthin:
         dann steht er über den Empfehlungen und unter dem Datumsblock. Sonst wie bisher direkt vor dem Warenkorb-Bereich. */
      var slot = doc.querySelector('[data-vfrb-slot="' + (el.classList.contains("cart-section") ? "seite" : "drawer") + '"]');
      if (slot) { if (box.parentNode !== slot) slot.appendChild(box); }
      else if (box.nextElementSibling !== el) el.parentNode.insertBefore(box, el);
      if (box.getAttribute("data-vfrb") !== html_) { /* kein Neuschreiben ohne Änderung (Ruhe für Screenreader und Layout) */
        box.setAttribute("data-vfrb", html_);
        box.innerHTML = html_;
      }
    });
  }

  /* Merkt den Code, solange er im Warenkorb angewendet war: Gilt später der höhere Mengenrabatt,
     zeigt der Balken weiter, bis wohin der Code gilt. Nur in dieser Sitzung (sessionStorage). */
  function gemerkterCode() {
    try { return JSON.parse(root.sessionStorage.getItem("vfrb_code") || "null"); } catch (e) { return null; }
  }
  function merke(c) {
    try { root.sessionStorage.setItem("vfrb_code", JSON.stringify(c)); } catch (e) { /* ohne Speicher: kein Merken */ }
  }

  function aktualisiere() {
    var jetzt = Date.now();
    if (jetzt - letzteAnfrage < 800) { /* nicht verwerfen, sondern nachholen */
      if (!nachholen) nachholen = root.setTimeout(function () { nachholen = null; aktualisiere(); }, 850 - (jetzt - letzteAnfrage));
      return;
    }
    if (!anker().length) return; /* Seite ohne Warenkorb-Bereich: nichts zu holen */
    if (!K()) return; /* ohne Stufen kein Balken: dann auch nichts holen (Prüfung 20.10.2026) */
    letzteAnfrage = jetzt;
    var nr = ++anfrageNr;
    (root.VFWarenkorbBasis ? root.VFWarenkorbBasis.holen() : root.fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }))
      .then(function (c) {
        if (nr !== anfrageNr) return; /* überholt: ein neuerer Stand ist unterwegs */
        var m = berechne(c, gemerkterCode());
        if (m.codeMerken) merke(m.codeMerken);
        zeichne(m);
        beobachte(); /* Formular und Kasten können vom Theme neu erzeugt worden sein (Theme-Editor) */
      })
      .catch(function () { /* ohne cart.js bleibt der Warenkorb unverändert */ });
  }

  function planen() {
    if (timer) return;
    timer = root.setTimeout(function () { timer = null; aktualisiere(); }, 400);
  }
  /* cart-updated ist eine sichere Meldung (Liste ist eben neu gezeichnet): sofort fragen, ohne Sammelfrist. Mit der Warenkorb-Basis
     kostet das keinen zusätzlichen Abruf (gemeinsamer Stand, nach Mengenänderungen aus der Antwort von /cart/change). */
  function sofort() {
    if (!root.VFWarenkorbBasis) { planen(); return; }
    if (timer) { root.clearTimeout(timer); timer = null; }
    letzteAnfrage = 0;
    aktualisiere();
  }

  /* Beobachtet nur, was das Theme beim Neuzeichnen des Warenkorbs ersetzt (den Inhalt von #AjaxCartForm und #AjaxCartSubtotal,
     assets/component-cart.js), und den Zähler im Kopf. Nicht den ganzen Warenkorb-Bereich: dort ändern Kalender, Empfehlungen,
     Termin-Karte und «Warenkorb leeren» laufend etwas, ohne dass sich der Warenkorb ändert, und jede Änderung kostete einen
     /cart.js-Abruf (Prüfung 16.10.2026). Der eigene Balken steht ausserhalb dieser Elemente. */
  var beobachter = null;
  function beobachte() {
    if (!beobachter) beobachter = new root.MutationObserver(planen);
    beobachter.disconnect();
    ["AjaxCartForm", "AjaxCartSubtotal"].forEach(function (id) {
      var el = doc.getElementById(id);
      if (el) beobachter.observe(el, { childList: true });
    });
    Array.prototype.forEach.call(doc.querySelectorAll("[data-header-cart-count]"), function (el) {
      beobachter.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function start() {
    if (startAnzahl !== 0) aktualisiere(); /* leerer Warenkorb: nichts zu holen; die erste Änderung meldet sich unten */
    beobachte();
    root.addEventListener("cart-updated", function () { sofort(); beobachte(); }, true); /* Theme meldet Warenkorb-Änderungen */
  }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", start); else start();
})(typeof window !== "undefined" ? window : globalThis);
